// extracted by mini-css-extract-plugin
module.exports = {"container-exit":"Exit_container-exit__ruoQi","content":"Exit_content__NoFIL","body":"Exit_body__1eE-7"};